/**
 * @file
 * Global utilities.
 *
 */

"use strict";

import fetch from "unfetch";
import objectFitImages from "object-fit-images";

(($, Drupal) => {
  // For IE.
  objectFitImages();

  Drupal.slnsw_oral_history_theme = {};

  // Change the text of Bootstrap collapse toggles.
  var handleCollapseChange = (targetId, collapsing) => {
    let links = $(`[data-toggle="collapse"][href="#${targetId}"]`);
    links.text(Drupal.t(collapsing ? "Show" : "Hide"));
  };
  Drupal.behaviors.slnsw_oral_history_bootstrap_collapse = {
    attach: function(context, settings) {
      $(".collapse", context).on("show.bs.collapse", e => {
        if (!e.target.id) {
          return;
        }
        handleCollapseChange(e.target.id, false);
      });

      $(".collapse", context).on("hide.bs.collapse", e => {
        if (!e.target.id) {
          return;
        }
        handleCollapseChange(e.target.id, true);
      });
    }
  };

  Drupal.behaviors.slnsw_oral_history_audio_player = {
    attach: function(context, settings) {
      const playerJsonSource = $("[data-oh-json]", context).data("oh-json");
      if (typeof playerJsonSource === "undefined") {
        return;
      }

      import("./initOhAudioPlayer.js").then(({ attach }) => {
        attach($, context, playerJsonSource);
      });
    }
  };

  // Custom XS collapse.
  Drupal.behaviors.slnsw_oral_history_xs_collapse = {
    attach: function(context, settings) {
      var collapser_btn = $(context).find("[data-oh-toggle]");
      var collapser = $(context).find(collapser_btn.attr("href"));

      collapser_btn.on("click", function(e) {
        e.preventDefault();
        collapser.toggleClass("oh-xs-collapse-show");
        if (collapser_btn.attr("aria-expanded") == "false") {
          collapser_btn.attr({
            "aria-expanded": "true",
            text: Drupal.t("Hide")
          });
        } else {
          collapser_btn.attr({
            "aria-expanded": "false",
            text: Drupal.t("Show")
          });
        }
      });
    }
  };

  // Download mp3.
  Drupal.behaviors.slnsw_oral_history_social_menu = {
    attach: function attach(context) {
      import("./generateDownloadDropdown").then(({ generateDownloadDropdown }) =>
        generateDownloadDropdown($, context)
      );
    }
  };

  // Print Transcript behavior.
  Drupal.behaviors.slnsw_oral_history_printPDF_jsPDF = {
    attach: function attach(context, settings) {
      let pdfButton = $(".dropdown-item-transcript", context);
      if (pdfButton.length) {
        import("./initPdfTranscript").then(({ initPdfTranscript }) => {
          pdfButton.on("click", e => {
            e.preventDefault();
            initPdfTranscript($, context);
          });
        });
      }
    }
  };

  // scroll to top fn.
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  // theme Behaviour.
  Drupal.behaviors.slnsw_oral_thme = {
    attach: function attach(context, settings) {
      var html_scroll_up_btn =
        '<div class="col-12 sticky-top sticky-top-scroll-top"><a href="#main-content" class="btn btn-sm d-block float-right py-1"><i class="fas d-block fa-chevron-up"></i>Back to top</a></div>';
      var transcript_container = $(context)
        .find(".oh-transcript")
        .closest(".oh-row-paragraphs");

      if (jQuery(".sticky-top-scroll-top", transcript_container).length == 0) {
        transcript_container.append(html_scroll_up_btn);
      }

      $(context).on("resize scroll", function() {
        $(".oh-transcript").each(function() {
          if ($(this).isInViewport()) {
            $("body").addClass("transcript-active");
          } else {
            $("body").removeClass("transcript-active");
          }
        });
      });
    }
  };
})(jQuery, Drupal);
